module.exports = __webpack_public_path__ + "img/banner5.fb21a19b.jpg";